package br.com.texeratx.boardgametimeapp.domain.usecases.player

import br.com.texeratx.boardgametimeapp.data.repository.PlayerRepository
import br.com.texeratx.boardgametimeapp.ui.screens.players.model.PlayerUI

class GetPlayerDetailUseCase(
    private val repository: PlayerRepository
) {
    suspend operator fun invoke(playerId: Long): Result<PlayerUI> {
        return repository.getPlayerById(playerId).map { dto ->
            PlayerUI(
                id = dto.id,
                name = dto.name,
                imageUrl = dto.imageUrl,
                nickname = dto.nickname,
                birthday = dto.birthday,
                phone = dto.phone,
                clanId = dto.clanId
            )
        }
    }
}
